import React, {
  useEffect,
  useState,
} from 'react';
import ReferringProviderContactDialog, {
  ReferringProviderContactDialogParams,
} from 'pages/Dashboard/pages/Encounters/pages/VisitNote/components/SendToReferringProviderDialog';
import {
  referringProviderEventChannel,
} from 'pages/Dashboard/services/eventChannels';

export default function ReferringProviderContactDialogHandler() {
  const [dialogParams, setDialogParams] = useState<ReferringProviderContactDialogParams | null>(null);

  useEffect(() => referringProviderEventChannel.on('onOpenContactDialog', setDialogParams), []);

  return dialogParams ? (
    <ReferringProviderContactDialog
      {...dialogParams}
      onClose={() => { setDialogParams(null); }}
    />
  ) : null;
}
